// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 60 60" {...rest} unit={unit}>
		<title>Bye</title>
		<g>
			<circle id="Oval" fill="#001F4A" cx="30" cy="30" r="30"></circle>
			<polygon id="Path" fill="#FFFFFF" points="18 42 18 18 42 18 42 42"></polygon>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Bye.js